import React, { useEffect, useRef, useState } from 'react';

// Libs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNodeId } from '@xyflow/react';

// Hooks
import { useNodeUpdate } from '~/hooks/useNodeUpdate';

// Utilitários
import { NodeHeaderCustomDeleteAction } from '~/utils/NodeHeaderCustomDeleteAction';
import { NodeHeaderCustomAlertAction } from '~/utils/NodeHeaderCustomAlertAction';
import { InputRichVariavel } from '~/utils/InputRichVariavel';
import { CustomHandle } from '~/utils/CustomHandle';

export const FundoNode = ({ data }) => {
    const id = useNodeId();
    const { onNodesChange } = useNodeUpdate();

    const [backgroundUrl, setBackgroundUrl] = useState(data.backgroundUrl || '');
    const [backgroundFit, setBackgroundFit] = useState(data.backgroundFit || 'cover');
    const [listaPendencias, setListaPendencias] = useState([]);

    const fileInputRef = useRef(null);

    useEffect(() => { setBackgroundUrl(data.backgroundUrl || ''); }, [data.backgroundUrl]);
    useEffect(() => { setBackgroundFit(data.backgroundFit || 'cover'); }, [data.backgroundFit]);

    const conferePendencias = () => {
        const pendencias = [];
        if (!backgroundUrl) pendencias.push('Imagem não preenchida');
        setListaPendencias(pendencias);
        return pendencias;
    };

    useEffect(() => { conferePendencias(); }, [backgroundUrl]);

    const handleUrlChange = (v) => {
        setBackgroundUrl(v);
        onNodesChange([{ id, type: 'update', data: { backgroundUrl: v } }]);
    };

    const handleFitChange = (e) => {
        const v = e.target.value;
        setBackgroundFit(v);
        onNodesChange([{ id, type: 'update', data: { backgroundFit: v } }]);
    };

    const handlePickFile = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            const result = typeof reader.result === 'string' ? reader.result : '';
            setBackgroundUrl(result);
            onNodesChange([{ id, type: 'update', data: { backgroundUrl: result } }]);
        };
        reader.readAsDataURL(file);

        // permite selecionar o mesmo arquivo novamente
        e.target.value = '';
    };

    return (
        <div className={`node ${data.highlighted ? 'highlighted' : ''}`}>
            <div className="titulo-node"><FontAwesomeIcon icon="fa-solid fa-diamond" />{data.label.toUpperCase()}</div>
            <div className="linha-separadora" />
            <div className="node-geral">
                <div className="node-botoes">
                    <button title="Executar este comando" onClick={() => alert('Executar')}><FontAwesomeIcon icon="fa-solid fa-circle-play" /></button>
                    <NodeHeaderCustomDeleteAction />
                    {listaPendencias.length > 0 && <NodeHeaderCustomAlertAction conferePendencias={conferePendencias} nodeData={data} />}
                </div>
                <div className="node-principal">
                    <div className="body-node"></div>

                    <span className="icon">Imagem (URL ou variável):</span>
                    <div style={{ width: '100%', maxWidth: 320, minWidth: 250 }}>
                        <InputRichVariavel
                            value={backgroundUrl}
                            onChange={handleUrlChange}
                            placeholder="https://... ou arraste uma variável"
                            multiline={false}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                        <button
                            type="button"
                            onClick={handlePickFile}
                            style={{
                                padding: '8px 10px',
                                cursor: 'pointer',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                background: '#fafafa'
                            }}
                            title="Selecionar imagem do computador"
                        >
                            <FontAwesomeIcon icon="fa-solid fa-upload" />
                        </button>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />

                        <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            Ajuste:
                            <select value={backgroundFit} onChange={handleFitChange}>
                                <option value="cover">Preencher</option>
                                <option value="contain">Encaixar</option>
                            </select>
                        </label>
                    </div>

                    {backgroundUrl && (
                        <div style={{ marginTop: 10, width: '100%' }}>
                            <div style={{ fontSize: 12, marginBottom: 6, opacity: 0.8 }}>Prévia:</div>
                            <div
                                style={{
                                    width: 220,
                                    height: 90,
                                    border: '1px solid #ddd',
                                    borderRadius: 6,
                                    overflow: 'hidden',
                                    backgroundImage: `url(${backgroundUrl})`,
                                    backgroundSize: backgroundFit,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center'
                                }}
                            />
                        </div>
                    )}

                    <CustomHandle type="target" position="top" connectionCount={1} allowLoopConnections={true} />
                    <CustomHandle type="source" position="bottom" connectionCount={1} />
                </div>
            </div>
        </div>
    );
};
